import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState, useEffect } from "react";
import { Dropdown, DropdownButton, Navbar, Nav, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../actions/auth";
import SwaggerContext from "../../SwaggerContext";
import appLogo from "../../resources/app-40.png";

const TopBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userApi } = useContext(SwaggerContext);
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    console.log("[TopBar] MONTADO");
    return () => console.log("[TopBar] DESMONTADO");
  }, []);

  return (
    <Navbar bg="dark" variant="dark" expand="lg" expanded={expanded}>
      <Container fluid>
        <Navbar.Brand as={Link} to={isLoggedIn ? "/inicio" : "/"} className="d-flex align-items-center">
          <img
            src={appLogo}
            alt="CEAEmociones"
            style={{ height: "32px", marginRight: "10px" }}
          />
          <span>Inicio</span>
        </Navbar.Brand>
        {isLoggedIn && (
          <Nav.Link as={Link} to="/sobre-el-proyecto" onClick={() => setExpanded(false)} className="text-light ms-2">
            Sobre el proyecto
          </Nav.Link>
        )}
        
        <Navbar.Toggle 
          aria-controls="navbarNav" 
          onClick={() => setExpanded(!expanded)}
        />

        <Navbar.Collapse id="navbarNav">
          <Nav className="me-auto">
            {isLoggedIn && user && user.role === "ADMIN" ? (
              <>
                <Nav.Link as={Link} to="/paginas" onClick={() => setExpanded(false)}>
                  Páginas
                </Nav.Link>
                <Nav.Link as={Link} to="/categorias" onClick={() => setExpanded(false)}>
                  Categorías
                </Nav.Link>
                <Nav.Link as={Link} to="/usuarios" onClick={() => setExpanded(false)}>
                  Usuarios
                </Nav.Link>
                <Nav.Link as={Link} to="/error-logs" onClick={() => setExpanded(false)}>
                  Errores
                </Nav.Link>
              </>
            ) : null}
            {isLoggedIn && user && (user.role_id === 3 || user.role === "ADMIN" || user.role === "THERAPIST") ? (
              <>
                <Nav.Link as={Link} to="/gestor-invitaciones" onClick={() => setExpanded(false)}>
                  Gestor de Invitaciones
                </Nav.Link>
                <Nav.Link as={Link} to="/mis-pacientes" onClick={() => setExpanded(false)}>
                  Mis Pacientes
                </Nav.Link>
              </>
            ) : null}
          </Nav>
          
          <div className="d-flex">
            <DropdownButton
              variant="secondary"
              id="dropdown-basic-button"
              align="end"
              title={
                <span>
                  <FontAwesomeIcon icon={faUser} />
                </span>
              }
            >
              <Dropdown.Item onClick={() => { navigate("/perfil"); setExpanded(false); }}>
                Perfil
              </Dropdown.Item>
              <Dropdown.Item onClick={() => { navigate("/estadisticas"); setExpanded(false); }}>
                Ver estadísticas
              </Dropdown.Item>
              <Dropdown.Item onClick={() => { navigate("/sobre-el-proyecto"); setExpanded(false); }}>
                Sobre el proyecto
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                onClick={() => {
                  dispatch(logout(userApi));
                  navigate("/login");
                  setExpanded(false);
                }}
              >
                Cerrar Sesión
              </Dropdown.Item>
            </DropdownButton>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default TopBar;
